import { useContext } from "react";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useUpdateFileAndInvalidateHistoryQueries } from "@/queries/refetch-files-and-history";
import { ProjectContext } from "@/stores/project-provider";

import { FileOrDirectoryEnum } from "../types/file-or-directory";

export const renameFileOrDirectory = async (
  projectId: string,
  id: string,
  type: FileOrDirectoryEnum,
  renameTo: string
) => {
  let newPath = id;
  if (type === "directory") newPath = newPath.slice(0, -1);
  const splitPath = newPath.split("/");
  if (splitPath.length === 1) {
    newPath = "";
  } else {
    newPath = splitPath.slice(0, -1).join("/") + "/";
  }

  const newName = type === "file" ? renameTo : renameTo + "/";

  return await getRanaApiV1().FilesApi[
    type === "file" ? "projectFileMove" : "projectDirectoryMove"
  ]({ sourcePath: id, destinationPath: newPath + newName, projectId });
};

export const useRenameProjectFileOrDirectory = () => {
  const { id: projectId } = useContext(ProjectContext);

  const updateFileAndInvalidateHistoryQueries = useUpdateFileAndInvalidateHistoryQueries();
  return useMutationWithErrorHandler(
    async ({ id, type, renameTo }: { id: string; type: FileOrDirectoryEnum; renameTo: string }) => {
      const file = await renameFileOrDirectory(projectId, id, type, renameTo);
      updateFileAndInvalidateHistoryQueries({ beforeId: id, file });
    }
  );
};
